import axios from '../../app/common/libs/http';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const fetchSentimentCount = createAsyncThunk(
  'voc/sentimentcount',
  async (payload) =>
    await axios.post(
      `${process.env.REACT_APP_VOCAPIURL}/Voc/sentimentcount`,
      payload
    )
);

export const fetchSentimentTrend = createAsyncThunk(
  'voc/sentimenttrend',
  async (payload) =>
    await axios.post(
      `${process.env.REACT_APP_VOCAPIURL}/Voc/sentimenttrend`,
      payload
    )
);

export const fetchTopicSummary = createAsyncThunk(
  'voc/trendingtopics',
  async (payload) =>
    await axios.post(
      `${process.env.REACT_APP_VOCAPIURL}/Voc/trendingtopics`,
      payload
    )
);

export const fetchDropdownCategories = createAsyncThunk(
  'voc/categories',
  async (payload) =>
    await axios.get(
      `${process.env.REACT_APP_VOCAPIURL}/Voc/categories/${payload.id}`
    )
);

export const fetchCategorySummary = createAsyncThunk(
  'voc/categorysummary',
  async (payload) =>
    await axios.post(
      `${process.env.REACT_APP_VOCAPIURL}/Voc/categorysummary`,
      payload
    )
);

export const fetchCategoryOverTime = createAsyncThunk(
  'voc/categoryovertime',
  async (payload) =>
    await axios.post(
      `${process.env.REACT_APP_VOCAPIURL}/Voc/categorydisplayedovertime`,
      payload
    )
);

export const fetchTrendingTopicsSearch = createAsyncThunk(
  'voc/trendingtopicssearch',
  async (payload) =>
    await axios.post(
      `${process.env.REACT_APP_VOCAPIURL}/Voc/trendingtopicssearch/${payload.keyword}`,
      payload
    )
);

export const fetchCommentsReport = createAsyncThunk(
  'voc/commentsreport',
  async (payload) =>
    await axios.post(
      `${process.env.REACT_APP_VOCAPIURL}/Voc/commentsreport`,
      payload
    )
);

export const fetchDynamicSearchReport = createAsyncThunk(
  'voc/dynamicsearchreport',
  async (payload) =>
    await axios.post(
      `${process.env.REACT_APP_VOCAPIURL}/Voc/dynamicsearch/${payload.keyword}`,
      payload
    )
);

export const fetchTreeReportTabsCount = createAsyncThunk(
  'voc/treereporttabscount',
  async (payload) =>
    await axios.post(
      `${process.env.REACT_APP_VOCAPIURL}/Voc/treereportsentimenttab`,
      payload
    )
);

export const fetchTreeReport = createAsyncThunk(
  'voc/treereport',
  async (payload) =>
    await axios.post(
      `${process.env.REACT_APP_VOCAPIURL}/Voc/treereport`,
      payload
    )
);

export const fetchTreeReportCategoryTopicComment = createAsyncThunk(
  'voc/treereportcategorytopicscomment',
  async (payload) =>
    await axios.post(
      `${process.env.REACT_APP_VOCAPIURL}/Voc/treereportcategorytopicscomment`,
      payload
    )
);

export const fetchTopVisitedSites = createAsyncThunk(
  'voc/topvisitedsites',
  async (payload) =>
    await axios.post(
      `${process.env.REACT_APP_VOCAPIURL}/Voc/topVistedSites`,
      payload
    )
);

export const fetchTopRatedSites = createAsyncThunk(
  'voc/topratedsites',
  async (payload) =>
    await axios.post(
      `${process.env.REACT_APP_VOCAPIURL}/Voc/topRatedSites`,
      payload
    )
);

export const fetchRatingDistribution = createAsyncThunk(
  'voc/ratingDistribution',
  async (payload) =>
    await axios.post(
      `${process.env.REACT_APP_VOCAPIURL}/Voc/ratingDistribution`,
      payload
    )
);

export const fetchSitesRatings = createAsyncThunk(
  'voc/sitesRatings',
  async (payload) =>
    await axios.post(
      `${process.env.REACT_APP_VOCAPIURL}/Voc/sitesRatings`,
      payload
    )
);
